export const notificacoes = {
  bell: 'Notificações',
  title: 'Notificações',
  empty: 'Nenhuma notificação ainda.',
  error: 'Não foi possível carregar as notificações.',
  kind: {
    atribuido: 'Novo conteúdo atribuído',
    prazo_7d: 'Prazo em 7 dias',
    prazo_1d: 'Prazo amanhã',
    concluido: 'Concluído',
  },
  vence: 'vence em {{data}}',
} as const;
